<div class="central-config-container">
    <div class="vertical-forms-container">
        <div class="header-container">
            <span class="h3-regular header-title">{{ 'central.central_config'|stringLiterals}}</span>
            <div class="button-container">
                <button tam-button tamType="primary" tamSize="normal" class="submit-button" [disabled]="false"
                    (click)="clickRegisterServer()">{{'central.register_server'|stringLiterals}}</button>
                <label class="comments"><span class="required-field">**</span>{{'general.required_fields_for_ssl'|
                    stringLiterals}}</label>
            </div>
        </div>
        <form [formGroup]="centralConfigForm">
            <div class="central-config-body control-border">
                <div class="email-form-left">
                    <!--firstHost-->
                    <div class="tam-form-field input-setting" [ngClass]="{'has-error': host.invalid}">
                        <label class="label-2 email-address">{{'central.host' |
                            stringLiterals}}&nbsp;<span class="required-field">*</span></label>
                        <input class="tam-input email-input" formControlName="host"
                            (blur)="clickCentralConfigChanged()" />
                        <div class="tam-form-help error-tip" *ngIf="host.invalid && host.errors['required']">
                            {{'general.required_error_message' | stringLiterals}}
                        </div>
                    </div>

                    <!--firstPort-->
                    <div class="tam-form-field input-setting" [ngClass]="{'has-error': port.invalid}">
                        <label class="label-2 email-address">{{'central.port' |
                            stringLiterals}}</label>
                        <input class="tam-input email-input" formControlName="port"
                            (blur)="clickCentralConfigChanged()" />
                    </div>

                    <!--isEnabledSSL-->
                    <div class="tam-form-field">
                        <label class="label-2 button-text">{{'central.ssl_enabled' |
                            stringLiterals}}</label>
                        <kendo-switch onLabel="On" offLabel="Off" formControlName="SSL"
                            (valueChange)="clickCentralConfigChanged()">
                        </kendo-switch>
                    </div>
                </div>
            </div>

            <div class="central-config-body control-border">
                <div class="email-form-left">
                    <div class="tam-form-field">
                        <label class="label-2 title-1">{{'central.tamale_central' | stringLiterals}}</label>
                    </div>

                    <!--secondHost-->
                    <div class="tam-form-field input-setting" [ngClass]="{'has-error': refdatasourceHost.invalid}">
                        <label class="label-2">{{'central.host' | stringLiterals}}&nbsp;<span
                                class="required-field">*</span></label>
                        <input class="tam-input email-input" formControlName="refdatasourceHost"
                            (keyup)="clickCentralConfigChanged()" />

                        <div class="tam-form-help error-tip" *ngIf="refdatasourceHost.invalid && refdataSSL.value">
                            {{'general.required_error_message' | stringLiterals}}
                        </div>
                    </div>

                    <!--secondPort-->
                    <div class="tam-form-field input-setting" [ngClass]="{'has-error': refdatasourcePort.invalid}">

                        <label class="label-2">{{'central.port' | stringLiterals}}&nbsp;<span
                                class="required-field">*</span></label>
                        <input class="tam-input email-input" formControlName="refdatasourcePort"
                            (keyup)="clickCentralConfigChanged()" />
                        <div class="tam-form-help error-tip" *ngIf="refdatasourcePort.invalid && refdataSSL.value">
                            {{'general.required_error_message' | stringLiterals}}
                        </div>

                    </div>

                    <!--userName-->
                    <div class="tam-form-field input-setting" [ngClass]="{'has-error': refdatasourceUsername.invalid}">
                        <label class="label-2">{{'central.username' | stringLiterals}}&nbsp;<span
                                class="required-field">**</span></label>
                        <input class="tam-input email-input" formControlName="refdatasourceUsername"
                            (blur)="clickCentralConfigChanged()" />
                        <div class="tam-form-help error-tip" *ngIf="refdatasourceUsername.invalid && refdatasourceUsername.errors['required'] &&
                            refdataSSL.value">
                            {{'general.required_error_message' | stringLiterals}}
                        </div>
                    </div>

                    <!--password-->
                    <div class="tam-form-field input-setting" [ngClass]="{'has-error': refdatasourcePassword.invalid}">
                        <label class="label-2">{{'central.password' | stringLiterals}}&nbsp;<span
                                class="required-field">**</span></label>
                        <input class="tam-input email-input" formControlName="refdatasourcePassword"
                            (blur)="clickCentralConfigChanged()" type="password" />

                        <div class="tam-form-help error-tip"
                            *ngIf="refdatasourcePassword.invalid && refdatasourcePassword.errors['required'] && refdataSSL.value">
                            {{'general.required_error_message' | stringLiterals}}
                        </div>
                    </div>

                    <!--version-->
                    <div class="tam-form-field input-setting"
                        [ngClass]="{'has-error': currentReferenceDataVersion.invalid}">
                        <label class="label-2">{{'central.version' | stringLiterals}}</label>
                        <input class="tam-input email-input" formControlName="currentReferenceDataVersion"
                            disabled="false" />
                    </div>

                    <!--dataSet-->
                    <div class="tam-form-field input-setting">
                        <label class="label-2">{{'central.dataset' | stringLiterals}}</label>
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" formControlName="refdataDataSet"
                            [data]="changeDataSet" class="email-type" [textField]="'stringValue'" [valueField]="'type'"
                            (valueChange)="clickCentralConfigChanged()">
                        </kendo-dropdownlist>
                    </div>

                    <!--connectionRetries-->
                    <div class="tam-form-field input-setting">
                        <label class="label-2">{{'central.connection_retries' | stringLiterals}}</label>
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                            formControlName="connectionRetries" [data]="changeConnectionRetries" class="email-input"
                            (valueChange)="clickCentralConfigChanged()">
                        </kendo-dropdownlist>
                    </div>

                    <!--isSecondSSL-->
                    <div class="tam-form-field">
                        <label class="label-2 button-text">{{'central.ssl' |
                            stringLiterals}}</label>
                        <kendo-switch onLabel="On" offLabel="Off" formControlName="refdataSSL"
                            (valueChange)="changeRefdataSSLStatus()">
                        </kendo-switch>
                    </div>

                    <!--initialLoad-->
                    <div class="tam-form-field">
                        <label class="label-2 button-text">{{'central.initial_load' |
                            stringLiterals}}</label>
                        <kendo-switch onLabel="On" offLabel="Off" formControlName="initialLoad"
                            (valueChange)="clickCentralConfigChanged()">
                        </kendo-switch>
                    </div>
                </div>
            </div>
            <!--submit-->
            <div>
                <button tam-button tamType="primary" tamSize="normal" class="submit-button"
                    [disabled]="isLoadingSubmit||!isChanged"
                    (click)="clickSubmitCentralConfig()">{{'general.submit'|stringLiterals}}</button>
            </div>
        </form>
    </div>
</div>